import { Link } from "react-router-dom";

type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-600 cursor-pointer">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-base leading-none text-foreground-400"></i>
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600 cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-foreground-800">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}